module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LC-9bc7f989f471a89cf2ee43dc80d1939a.png";